import { useCallback } from "react";
import { AlmeMessageEventData } from "@alme/post-message-api/AlmeMessageEventData";
import { AlmeLaunchIvaMessageEventData } from "@alme/post-message-api/AlmeLaunchIvaMessageEventData";
import { AlmeAppState } from "../components/AlmeApp/AlmeAppState";
import { AlmeApiUtils } from "../api/AlmeApiUtils";
import defaultLogger from '../Logger';

export function useLaunchIvaCallback(almeState: AlmeAppState,
    isInitialized: React.MutableRefObject<boolean>,
    setAlmeState: (state: AlmeAppState) => void,
    apiUtils: React.MutableRefObject<AlmeApiUtils>,
    setPulse: (value: boolean) => void,
    scrollToResponse: { current: boolean },
    isIvaProLaunch?: React.MutableRefObject<boolean>,
): (payload: AlmeMessageEventData) => void {
    // eslint-disable-next-line sonarjs/cognitive-complexity
    return useCallback((payload: AlmeMessageEventData): void => {
        const launchPayload = payload as AlmeLaunchIvaMessageEventData;
        try {
            if (typeof launchPayload?.message?.type === "string" && launchPayload?.message?.type?.toLowerCase() === 'launchiva') {
                defaultLogger.log('useLaunchIvaCallback: ', launchPayload);
                const launchQuestion = launchPayload?.message?.launchQuestion?.trim();
                if (!almeState.isOpen) {
                    if (!isInitialized.current) {
                        // if not open and not initialized add this to state to happen on init.
                        scrollToResponse.current = true;
                        if (isIvaProLaunch)
                            isIvaProLaunch.current = false;
                        setAlmeState({
                            ...almeState,
                            launchQuestion: launchPayload.message.launchQuestion || undefined,
                            launchData: launchPayload,
                            isMinimized: false,
                        });
                    } else if (launchQuestion && typeof launchQuestion === "string" && almeState.isMinimized) {
                        // IVA was minimized. Open and send question.
                        setAlmeState({
                            ...almeState,
                            isOpen: true,
                            isMinimized: false,
                        });
                        void apiUtils.current.submitAlmeInput(launchQuestion);
                    } else {
                        // Iva was minimized. Just open.
                        setAlmeState({
                            ...almeState,
                            isOpen: true,
                            isMinimized: false,
                        });
                    }
                } else if (launchQuestion) {
                    // IVA is already open.  Send question.
                    void apiUtils.current.submitAlmeInput(launchQuestion);
                } else {
                    // IVA is already open
                    setPulse(true);
                }
            }
        } catch (error) {
            defaultLogger.error('Error executing launchIva callback', error);
        }
    }, [almeState, isInitialized, scrollToResponse, isIvaProLaunch, setAlmeState, apiUtils, setPulse]);
}